export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10586.f8d4a26a.jpg";